import React from "react";
import { Link } from "react-router-dom";
import { Users } from "lucide-react";

const JoinUsBanner = () => {
  return (
    <div className="relative py-16 px-4">
      {/* Background image + Overlay */}
      <div
        className="absolute inset-0 bg-[url('/src/assets/image/team.jpg')] bg-cover bg-center z-0 rounded-2xl"
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 bg-black/60 z-10 rounded-2xl"
        aria-hidden="true"
      />

      {/* Content */}
      <div className="relative z-20 max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-8 px-8 py-12 ">
        {/* Right Content */}
        <div className="md:pl-6 flex-1">
          <h2 className="text-2xl md:text-3xl font-bold text-primary mb-4 leading-snug drop-shadow-sm">
            স্বেচ্ছাসেবক হোন
          </h2>
          <p className="mb-6 text-white dark:text-gray-200 leading-relaxed">
            আপনি কি একজন স্বেচ্ছাসেবক হতে প্রস্তুত? আপনি আমাদের সাথে
            স্বেচ্ছাশ্রমের মাধ্যমে আপনার সময়, দক্ষতা এবং জ্ঞান অবদান রাখতে
            পারেন। এটি একটি ইতিবাচক প্রভাব তৈরি করার একটি সুযোগ এবং শান্তি ও
            উন্নয়ন অর্জনের জন্য একটি গুরুত্বপূর্ণ শক্তি। অনেকের জীবনে একটা
            পার্থক্য গড়ে তুলুন!
          </p>
          <Link
            to="/register"
            className="inline-flex items-center justify-center gap-2 bg-primary hover:bg-primary/90 text-white font-bold py-3 px-6 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg"
          >
            এখনি যোগ দিন
          </Link>
        </div>
      </div>
    </div>
  );
};

export default JoinUsBanner;
